module.exports = __webpack_public_path__ + "static/media/discoverIcon.683814c3.png";